import React from 'react';
import SectionAboutTestimonial from './SectionAboutTestimonial';

const LANG = [
    'English',
    'Español',
    'Česky',
    'Slovensky',
];

const SKILLS = [
    'HTML',
    'CSS',
    'React',
    'BEM',
    'jQuery',
    'JavaScript',
    'Responsive Design',
    'Git',
    'Scss',
    'Bootstrap framework',
    'CSS Animations',
    'Adobe Photoshop',
    'Adobe InDesign',
    'Adobe Illustrator'
];

function SectionAbout() {
    const yearsExperience = new Date().getFullYear() - 2009;

    return (
        <section className="about">
            <article className="about__intro">
                <h2 className="about__heading">About</h2>
                <p>I became self employed <strong>{yearsExperience} years ago</strong> right after my university studies. Despite having studied marketing communication, I work as a <strong>HTML/CSS Frontend Developer</strong>. I also work as a <strong>DTP Operator</strong>, preparing materials for print. At the moment, a large number of my clients are from Slovakia and Czechia. I very much adore the freedom to travel my job gives me, while at the same time earning a living. I am from Bratislava, Slovakia and currently living in Barcelona ❤️</p>
            </article>
            <div className="about__testimonial">
                <h2 className="about__heading">Testimonials</h2>
                <SectionAboutTestimonial />
            </div>
            <div className="about__skills">
                <h2 className="about__heading">Skills:</h2>
                <ul className="about__skills-list">
                    {SKILLS.map((skill) => (
                        <li key={skill}>{skill}</li>
                    ))}
                </ul>
                <h2 className="about__heading">Languages: </h2>
                <ul className="about__skills-list about__skills-list--languages">
                    {LANG.map((skill) => (
                        <li key={skill}>{skill}</li>
                    ))}
                </ul>
            </div>
        </section>
    );
}

export default SectionAbout;